import {useQuery} from '@tanstack/react-query'
import {QUERY_KEYS} from './keys'
import {getMicromorgiPackagesV3} from '../services/micromorgi.http'

export const useFetchMicromorgiPackagesV3 = () => {
    return useQuery({
        queryKey: [QUERY_KEYS.micromorgiPackagesV3],
        queryFn: () => getMicromorgiPackagesV3()
    })
}
